import { ComponentSpinPage, SharedButton, StyledPreview } from "@components";
import { BLANK_IMAGE_URL } from "@configs";
import { IBenefit, IMembershipTier } from "@interfaces";
import { selectAuth, selectMerchant } from "@redux";
import { RenderMeta } from "@utils";
import { Avatar, Card, Skeleton } from "antd";
import Meta from "antd/lib/card/Meta";
import Parser from "html-react-parser";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";
import SwiperCore, { Navigation, Pagination } from "swiper";
import "swiper/components/navigation/navigation.min.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { Points } from "../shared/Point";

interface IProps {
    data: IBenefit;
    handleToggleConfirm: () => void;
    dataRanks: IMembershipTier[];
    handleChangeImage: (swiper: SwiperCore) => void;
    currentImage: number;
}
SwiperCore.use([Navigation, Pagination]);

export const ComponentBenefitDetail = (props: IProps) => {
    //hook
    const { t } = useTranslation();
    //redux state
    //@ts-ignore
    const { themes } = useSelector(selectMerchant);
    const { showConfirm } = useSelector(selectAuth);
    // props
    let { data, handleToggleConfirm, dataRanks, handleChangeImage, currentImage } = props;
    const [spinning, setSpinning] = useState<boolean>(true);
    useEffect(() => {
        if (data) {
            setSpinning(false);
        }
    }, [data]);

    const loadingComponent = (
        <StyledLoading>
            <StyledCard>
                <Skeleton loading active>
                    <Meta
                        avatar={<Avatar src="https://api.dicebear.com/7.x/miniavs/svg?seed=2" />}
                        title="Card title"
                        description="This is the description"
                    />
                </Skeleton>
            </StyledCard>
        </StyledLoading>
    );

    return (
        <>
            {data !== null &&
            themes?.themeColor !== null &&
            dataRanks !== null &&
            showConfirm !== null &&
            t !== null &&
            handleToggleConfirm !== null &&
            handleChangeImage !== null &&
            currentImage !== null ? (
                <>
                    <RenderMeta title={t("meta.benefit_detail", { name: data.name })} />
                    <StyledBenefitPage showConfirm={showConfirm}>
                        <div className="content-layout-fullpage">
                            <div className="topic-page">Benefit</div>
                            <div className="content-fullpage">
                                <div className="header-product">
                                    <div className="layout-img">
                                        <div className="img-product">
                                            <img src={data.imageUrl[0]} />
                                        </div>
                                    </div>
                                    <div className="topic-product">{data.name}</div>
                                    <div className="point-product">
                                        <span>
                                            <Points size={16} />
                                        </span>
                                        100 Points
                                    </div>
                                    <div className="expier-product">EXP : 1 Feb - 30 Mar 2023</div>
                                    <div className="total-point-product">Total 300 Rewards</div>
                                </div>
                                <div className="interception">
                                    <div className="cutter left"></div>
                                    <div className="middle-cutter"></div>
                                    <div className="cutter right"></div>
                                </div>
                                <div className="content-product">
                                    <div className="topic-detail">Conditions</div>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                        do eiusmod tempor incididunt ut labore et dolore magna
                                        aliqua Lorem ipsum dolor sit amet, consectetur adipiscing
                                        elit, sed do eiusmod tempor incididunt ut labore et dolore
                                        magna aliqua Lorem ipsum dolor sit amet, consectetur
                                        adipiscing elit, sed do eiusmod tempor incididunt ut labore
                                        et dolore magna aliqua
                                    </p>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                        do eiusmod tempor incididunt ut labore et dolore magna
                                        aliqua Lorem ipsum dolor sit amet, consectetur adipiscing
                                        elit, sed do eiusmod tempor incididunt ut labore et dolore
                                        magna aliqua Lorem ipsum dolor sit amet, consectetur
                                        adipiscing elit, sed do eiusmod tempor incididunt ut labore
                                        et dolore magna aliqua
                                    </p>
                                    <StyledUsedBtn
                                        className="btn-redeem"
                                        themeColor={themes?.themeColor!}
                                        onClick={handleToggleConfirm}
                                    >
                                        Claim Reward
                                    </StyledUsedBtn>
                                </div>
                            </div>
                        </div>
                    </StyledBenefitPage>
                    <StyledBenefitPreview showConfirm={showConfirm}>
                        {spinning ? (
                            <ComponentSpinPage children={loadingComponent} />
                        ) : (
                            <div className="page_body">
                                {data.imageUrl.length ? (
                                    <div className="pagination">
                                        {currentImage}/{data.imageUrl.length}
                                    </div>
                                ) : (
                                    <></>
                                )}
                                <div className="img-field">
                                    <Swiper
                                        slidesPerView={1}
                                        pagination={true}
                                        scrollbar={{ draggable: true }}
                                        onActiveIndexChange={handleChangeImage}
                                    >
                                        {data.imageUrl.length ? (
                                            data.imageUrl.map((item, index) => (
                                                <SwiperSlide key={index}>
                                                    <div className="img-wrap">
                                                        <img src={item} />
                                                    </div>
                                                </SwiperSlide>
                                            ))
                                        ) : (
                                            <SwiperSlide>
                                                <div className="img-wrap">
                                                    <img
                                                        className="empty-img"
                                                        src={BLANK_IMAGE_URL}
                                                    />
                                                </div>
                                            </SwiperSlide>
                                        )}
                                    </Swiper>
                                </div>

                                <div className="name-field">
                                    <h5 className="text-sub-header">{data.name}</h5>
                                    <StyledMField>
                                        {data?.levelIds?.length !== 0 &&
                                            dataRanks.map((item) => (
                                                <>
                                                    {!item.isDefault && (
                                                        <StyledMembership
                                                            key={item._id}
                                                            bgColor={item.color}
                                                        >
                                                            {item.iconUrl && (
                                                                <img src={item.iconUrl} />
                                                            )}
                                                            <p className="membershipName">
                                                                {item.membershipName}
                                                            </p>
                                                        </StyledMembership>
                                                    )}
                                                </>
                                            ))}
                                    </StyledMField>
                                </div>
                                <div className="description-field">
                                    {data.description && (
                                        <>
                                            <h5 className="text-sub-header">
                                                {t("page.description")}
                                            </h5>
                                            <div className="normal-text">
                                                {Parser(data.description)}
                                            </div>
                                        </>
                                    )}
                                    <div className="use_point">
                                        <StyledButton
                                            size="large"
                                            bg_color={themes?.themeColor!}
                                            type="submit"
                                            className="btn-text"
                                            onClick={handleToggleConfirm}
                                        >
                                            {t("page.redeem_benefit")}
                                        </StyledButton>
                                    </div>
                                </div>
                            </div>
                        )}
                    </StyledBenefitPreview>
                </>
            ) : (
                <></>
            )}
        </>
    );
};

const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.themeColor};
    background: ${(p) => p.theme.colors.card};
    border: 0.5px solid ${(p) => p.themeColor};
    border-radius: 16px;
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    &:active {
        background: ${(p) => p.themeColor};
        color: ${(p) => p.theme.colors.color};
    }
`;

const StyledBenefitPage = styled.div<{ showConfirm: boolean }>`
    .content-layout-fullpage {
        height: 100vh;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #f2e8d7;
        padding-top: 24px;
        padding-bottom: 24px;
        width: 100%;
        animation: bottomtotop 0.5s !important;
        position: relative;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        @media (max-width: ${(p) => p.theme.breakPoints.breakMobileMax}) {
            overflow: scroll;
        }
        .topic-page {
            font-size: 20px;
            text-align: center;
            color: #000;
            font-weight: 600;
        }
    }
    .content-fullpage {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        top: 50%;
        transform: translateY(-52%);
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            border-radius: 16px;
            padding: 20px;
        }
        .btn-redeem {
            color: #fff;
            background-color: #336c51;
            width: 100%;
            padding: 10px 0;
            font-size: 13px;
        }
        .header-product {
            // border-bottom: 1px solid #F0F0F0;
            padding: 20px;
            .layout-img {
                text-align: center;
                .img-product {
                    width: 141px;
                    height: 141px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
            }
            .total-point-product {
                text-align: center;
                color: #c4a363;
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
            }
        }
        .content-product {
            padding: 16px;
            margin-bottom: 50px;
            text-align: center;
            .topic-detail {
                text-align: center;
                color: #336c51;
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #9b9b9b;
                margin-bottom: 16px;
            }
        }
        .interception {
            width: 100%;
            // border-bottom: 5px dotted ${(p) => p.theme.colors.cutter};
            border-bottom: 5px dotted #eaeeff;
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                // background: ${(p) => p.theme.colors.cutter};
                background-color: #f2e8d7;
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #fff;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            padding: 8px 24px 24px 24px;
            background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 10px;
                line-height: 14px;
                text-align: center;
                color: #000000;
            }
        }
    }
`;

const StyledCard = styled(Card)`
    border: 1px solid #f0f0f0 !important;
`;

const StyledMField = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

const StyledButton = styled(SharedButton)`
    margin: 24px auto;
`;

const StyledMembership = styled.div<{ bgColor: string }>`
    background-color: ${(p) => p.bgColor};
    margin-right: 8px;
    color: white;
    font-weight: 600px;
    width: fit-content;
    max-width: 100px;
    padding: 4px 8px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 8px;
    span {
        width: fit-content;
        min-width: 26px;
    }
    img {
        width: 12px;
        height: 12px;
    }
    p.membershipName {
        margin-bottom: 0px;
        margin-left: 6px;
        font-size: 8px;
        font-weight: 500;
        color: #ffffff;
    }
`;

const StyledBenefitPreview = styled(StyledPreview)`
    .description-field {
        margin: 10px 0 0 0;
    }
`;

const StyledLoading = styled.div`
    margin-top: 25px;
    padding: 0 24px;
    .card {
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 1px 3px 6px rgba(0, 0, 0, 0.23);
        margin-bottom: 28px;
        background-color: ${(p) => p.theme.colors.card};
        display: flex;
        width: 100%;
        position: relative;
        flex-direction: column;
        .img {
            width: 100%;
            height: 170px;
            @media (max-width: 375px) {
                width: 100%;
                height: 130px;
            }
        }
        .content {
            flex: 1;
            .content {
                margin: 0 20px;
            }
        }
    }
`;
